import { StartingType } from '../enums';

export const DEFAULT_STARTING_TYPE = StartingType.DOL;
